import { Box, Typography } from "@mui/material";
import LoadingWheel from "../../../LoadingWheel/LoadingWheel";
import { TRYP_SVGS } from "../../../../../constants";
import { purple, white } from "../../../../../theme/colours";

const StatDisplay = ({ type, value, isOverall = false }) => {
  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    p: isOverall ? "0.75rem 1rem" : "0.5rem 1rem",
    borderBottom: isOverall && "2px solid #CFCDD6",
    mb: isOverall && "0.5rem",
    overflow: "hidden",
  };
  const typeStyle = {
    fontWeight: isOverall ? 700 : 500,
    textTransform: "capitalize",
    whiteSpace: "nowrap",
  };
  const valueStyle = {
    fontWeight: 700,
  };

  const imgStyle = {
    width: "1.3rem",
    height: "1.3rem",
    mr: "0.75rem",
    display: "flex",
    justifyContent: "center",
    "& svg *": {
      fill: purple[1],
    },
  };

  return (
    <Box key={type} sx={containerStyle}>
      <Box display="flex" alignItems="center">
        <Box sx={imgStyle}>
          {TRYP_SVGS[type !== "braking" ? type : "brake"]}
        </Box>
        <Typography variant="body2" sx={typeStyle}>
          {type !== "total" ? type : "Overall Score"}
        </Typography>
      </Box>
      <Typography variant="body2" sx={valueStyle}>
        {value}
      </Typography>
    </Box>
  );
};

const StatsCard = ({ style, scores, isLoading }) => {
  const containerStyle = {
    ...style,
    backgroundColor: white,
    display: "flex",
    flexDirection: "column",
    pb: "0.5rem",
  };

  return (
    <Box sx={containerStyle}>
      {isLoading ? (
        <LoadingWheel width={3} />
      ) : (
        <>
          <StatDisplay type="total" value={scores.total} isOverall />
          {Object.entries(scores).map(([key, value]) => {
            if (key === "total") {
              return null;
            }
            return <StatDisplay key={key} type={key} value={value} />;
          })}
        </>
      )}
    </Box>
  );
};

export default StatsCard;
